<template lang="pug">
  WtTile#ChartChallenge(ancestor vertical)
    WtTile(parent)
      WtTile
        .level.challenge-header
          .level-left
            .column
              .level.challenge-header-title
                .level-item
                  WtTitle.pr-2(h1 v-if="!_.isEmpty(getChallengeById(challengeId))") {{ getChallengeById(challengeId).name }}
                    //- TODO:
                    //- change 'initiator' to 'admin' (awaiting API changes)
                  RouterLink(
                    v-if="showChallengeEditButton"
                    :to="{ name: editChallengeRoute, params: { challengeId } }"
                  )
                    BIcon(icon="settings" size="is-small")
              .subtitle.level-item(v-if="!fullPageLoader && !isCompleted") {{ challengeDates() }}&nbsp;&nbsp;
                ChallengeJoinButton(:challenge="getChallengeById(challengeId)")
          .level-right
            .level-item
              WtButton(isRouterLink to="/challenges" color="primary") BACK TO ALL CHALLENGES
    WtTile(parent)
      WtTile.challenge-chart-container(child :is-loading="!leaderboardLoaded")
        WtLeaderboard(
          title=""
          :sub-title="leaderboardSubTitle"
          :data="{ data: getLeaderboardById(challengeId) }"
          :isTeamChallenge="getChallengeById(challengeId).between === 'groups'"
          isChallenge
          :loadedStatus="leaderboardLoaded"
          :goalLine="challenge.totalStepsGoal"
          :stepsOrActivitiesText="challenge.stepsOrActivitiesText"
          :trackingCalc="challenge.trackingCalc"
          :showTooltipLabel="false"
        )
        WtPagination(
          :paginationObject="getLeaderboardById(challengeId, 'pagination')"
          @currentPage="currentLeaderboardPage = $event"
          order="is-centered"
        )

    WtTile
      WtTile(vertical :col="4")
        WtTile(parent)
          WtTile(child :col="12" :is-loading="!challengeLoaded")
            ChallengeOverview(
              :challenge="getChallengeById(challengeId)"
            )
        WtTile(parent)
          WtTile(child :col="12" :is-loading="!challengeLoaded")
            ChallengeActivityOverview(
              :challenge="getChallengeById(challengeId)"
              :member-steps="thisMembersSteps"
            )
      WtTile(vertical)
        WtTile(parent v-if="coreProgramMeta.challengeDiscussion")
          WtTile(child :col="12" :is-loading="!discussionLoaded || joining || !challengeLoaded")
            Discussion(
              title="Challenge Discussion Board"
              :data-object="getDiscussionById(challengeId)"
              :fetch-action="fetchDiscussion"
              :challenge="getChallengeById(challengeId)"
            )

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { challengeMixin } from "@/mixins/challengeMixin";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { fetchAllMixin } from "@/mixins/fetchAllMixin";
import WtButton from "@@/WtButton/WtButton";
import WtJoinButton from "@@/WtJoinButton/WtJoinButton";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtPagination from "@@/WtPagination/WtPagination";
import WtLeaderboard from "@@/WtLeaderboard/WtLeaderboard";
import Discussion from "@@/Challenge/Discussion";
import ChallengeOverview from "@@/Challenge/ChallengeOverview";
import ChallengeActivityOverview from "@@/Challenge/ChallengeActivityOverview";
import ChallengeJoinButton from "@@/Challenge/ChallengeJoinButton";

export default {
  name: "ChartChallenge",

  components: {
    WtButton,
    WtJoinButton,
    WtTile,
    WtTitle,
    WtLeaderboard,
    Discussion,
    ChallengeOverview,
    ChallengeActivityOverview,
    ChallengeJoinButton,
    WtPagination
  },

  mixins: [dateUtilityMixin, fetchAllMixin, challengeMixin],

  data() {
    return {
      challengeLoaded: false,
      reloadPage: false,
      currentLeaderboardPage: 1
    };
  },

  computed: {
    ...mapGetters("pages", ["isPageLoaded", "isPageLoading"]),
    ...mapGetters("authMember", ["isAdmin"]),
    ...mapGetters("challenges", [
      "getDiscussionById",
      "discussionLoaded",
      "getLeaderboardById",
      "leaderboardLoaded",
      "getAggregateById",
      "aggregateLoaded",
      "joining",
      "getChallengeById"
    ]),
    ...mapGetters("members", [
      "getMilestonesById",
      "milestonesLoaded",
      "challenges",
      "memberTeamsLoaded"
    ]),
    ...mapGetters("program", ["coreProgramMeta", "programTeamsLoaded"]),

    showChallengeEditButton() {
      if (this._.isEmpty(this.challenge)) return false;
      if (this.challenge.isPvsPChallenge) return false;

      let isAdmin =
        this.challenge.initiator.id === this.$auth.user().id ||
        this.$auth.user().isAdmin;

      return isAdmin;
    },

    editChallengeRoute() {
      return this.$auth.user().isAdmin
        ? "ChallengeEditAdmin"
        : "ChallengeEditMember";
    },

    page() {
      return `Challenge${this.challengeId}`;
    },

    leaderboardSubTitle() {
      const activityText = this._.get(
        this.challenge,
        "stepsOrActivitiesText",
        "steps"
      );
      if (this.challenge.isPvsPChallenge) {
        return `Program Average ${activityText} In Challenge`;
      }
      if (this.challenge.between === "groups") {
        return this.challenge.trackingCalc
          ? `Team Total ${activityText} In Challenge`
          : `Team Average ${activityText} In Challenge`;
      }
      return `Total ${activityText} In Challenge`;
    },

    fullPageLoader() {
      // since there is no intial state for 'isPageLoading(this.page)'
      if (this._.isUndefined(this.isPageLoading(this.page))) {
        return true;
      }
      return this.isPageLoading(this.page);
    },

    challengeId() {
      return this.$route.params.challengeId;
    },

    showMap() {
      return (
        this.leaderboardLoaded && this.challengeLoaded && this.milestonesLoaded
      );
    },

    isCompleted() {
      const COMPLETED = 2;
      return (
        this.getChallengeById(this.$route.params.challengeId).status ===
        COMPLETED
      );
    },

    thisMembersSteps() {
      if (this.showMap) {
        const leaderboard = this.getLeaderboardById(this.challengeId);
        const member = leaderboard.find(member => {
          return member.id === this.$auth.user().id;
        });
        return member ? member.steps : null;
      }
      return 0;
    },

    challenge() {
      return this.getChallengeById(this.challengeId);
    }
  },

  watch: {
    challenge: {
      immediate: true,
      handler: function(challenge) {
        if (!this._.isEmpty(challenge)) {
          this.challengeLoaded = true;
        } else {
          this.challengeLoaded = false;
        }
      }
    },

    async currentLeaderboardPage() {
      await this.fetchLeaderboard({
        challengeId: this.challenge.id,
        page: this.currentLeaderboardPage,
        perPage: 15
      });
    }
  },

  methods: {
    ...mapActions("pages", ["setPageLoaded", "setPageLoading"]),
    ...mapActions("challenges", [
      "fetchChallenge",
      "join",
      "fetchChallengeDiscussion",
      "fetchLeaderboard",
      "fetchChallengeAggregate"
    ]),
    ...mapActions("members", ["fetchMilestones", "fetchMemberTeams"]),
    ...mapActions("program", ["fetchProgramTeams"]),
    ...mapActions(["snackBar"]),

    fetchDiscussion(photosOnly = false, page = null) {
      return this.fetchChallengeDiscussion({
        challengeId: this.challengeId,
        photosOnly,
        page
      });
    },

    challengeDates() {
      return (
        this.date(
          this.getChallengeById(this.challengeId).startDate,
          "DATE_FORMAT_SLASH"
        ).formatted +
        " - " +
        this.date(
          this.getChallengeById(this.challengeId).endDate,
          "DATE_FORMAT_SLASH"
        ).formatted
      );
    }
  }
};
</script>

<style lang="sass" scoped>
#ChartChallenge
  .challenge-header
    width: 100%
    .column
      padding-left: 0
    .challenge-header-title
      margin-bottom: .5rem
    .level-item
      justify-content: flex-start
  .challenge-chart-container
    height: 535px
    +mobile
      height: auto
</style>
